import { useState } from 'react'
import { useEffectOnce } from './use-effect-once'

export const usePageIsLoading = () => {
  const [loading, setLoading] = useState(false)

  useEffectOnce(() => {
    const setIsLoading = () => {
      setLoading(true)
    }

    const setIsNotLoading = () => {
      setLoading(false)
    }

    window.___emitter.on('onDelayedLoadPageResources', setIsLoading)
    window.___emitter.on('onPostLoadPageResources', setIsNotLoading)

    return () => {
      window.___emitter.off('onDelayedLoadPageResources', setIsLoading)
      window.___emitter.off('onPostLoadPageResources', setIsNotLoading)
    }
  })

  return loading
}
